import {
  MERCHANT_PLATFORMS_WITH_FULL_DETAILS,
  MerchantPlatformNames,
} from 'constants/merchantPlatforms';

import { useGetOne } from 'react-admin';
import { Merchant, MerchantPlatform } from 'types/embedded/merchant';

type ReturnValues = {
  enableAdditionalFields: boolean;
};

export function useEnableAdditionalFields(merchantId?: string): ReturnValues {
  const { data: merchant } = useGetOne<Merchant>(
    'merchants',
    { id: merchantId },
    { enabled: !!merchantId },
  );

  const { data: merchantPlatform } = useGetOne<MerchantPlatform>(
    'merchant_platforms',
    {
      id: merchant?.platform?.['@id'],
    },
    {
      enabled: !!merchant?.platform?.['@id'],
    },
  );

  const platformName = merchantPlatform?.name;

  const enableAdditionalFields = merchantId
    ? MERCHANT_PLATFORMS_WITH_FULL_DETAILS.includes(platformName as MerchantPlatformNames)
    : false;

  return { enableAdditionalFields };
}
